/* ABCD – winkelwagen (stijl: assets/abcd-cart-compact.css).
   1. Dunne "Jouw voordeel"-kaart: de kaart zelf komt uit assets/abcd-ladder.js; dit script zet .is-compact
      erop en voegt de knop "Details" toe. Of de klant de kaart open heeft geklapt onthouden we voor dit
      bezoek (sessionStorage).
   2. "Vaak samen gekocht" (2026-10-24): cdp-cart.js vraagt /recommendations/products.json (complementary,
      daarna related) en kreeg zo vooral hetzelfde model in een andere kleur. We beantwoorden die vragen met
      een vaste lijst accessoires: kleine bedragen zonder maatgedoe, dus makkelijk erbij te pakken.
      Zelfde JSON-vorm als /products/<handle>.js; producten die niet te koop zijn vallen weg.
      Lijst aanpassen = de handles in ACCESSORIES hieronder wijzigen. */
(function () {
  var ACCESSORIES = [
    'nike-everyday-cushioned-sports-socks-3-pack-white',
    'nike-everyday-cushioned-sports-socks-3-pack-black',
    'rl-beanie',
    'chrome-glasses',
    'travis-scott-veters-zwart',
    'travis-scott-veters-wit',
    'travis-scott-veters-beige',
    'rl-big-pony-beanie'
  ];

  /* ---------- 2. accessoires als aanbevelingen ---------- */
  var nativeFetch = window.fetch && window.fetch.bind(window);
  var accReq = null;
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function accessories() {
    if (!accReq) {
      accReq = Promise.all(ACCESSORIES.map(function (h) {
        return nativeFetch(root() + 'products/' + h + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (list) { return list.filter(function (p) { return p && p.available; }); });
    }
    return accReq;
  }
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.indexOf('/recommendations/products.json') !== -1 && /[?&]intent=(complementary|related)\b/.test(url)) {
        return accessories().then(function (products) {
          return new Response(JSON.stringify({ products: products }), { status: 200, headers: { 'Content-Type': 'application/json' } });
        });
      }
      return nativeFetch(input, init);
    };
  }

  /* ---------- 1. dunne voordeel-kaart ---------- */
  var KEY = 'abcd_lad_open';
  var lang = (document.documentElement.lang || 'nl').slice(0, 2);
  var L = {
    nl: ['Details', 'Minder'],
    fr: ['Détails', 'Moins'],
    de: ['Details', 'Weniger'],
    it: ['Dettagli', 'Meno'],
    en: ['Details', 'Less']
  }[lang] || ['Details', 'Minder'];

  function isOpen() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function remember(open) { try { sessionStorage.setItem(KEY, open ? '1' : '0'); } catch (e) {} }

  function render(lad, btn, open) {
    lad.classList.toggle('is-compact', !open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.firstChild.textContent = open ? L[1] : L[0];
  }

  function setup(lad) {
    var top = lad.querySelector('.AbcdLad__top');
    if (!top || top.querySelector('.AbcdLad__toggle')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'AbcdLad__toggle';
    btn.innerHTML = '<span></span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
    btn.addEventListener('click', function () {
      var open = lad.classList.contains('is-compact');
      remember(open);
      render(lad, btn, open);
    });
    top.appendChild(btn);
    render(lad, btn, isOpen());
  }

  function scan() {
    var lads = document.querySelectorAll('#CartDrawerPro .AbcdLad');
    for (var i = 0; i < lads.length; i++) setup(lads[i]);
  }

  // abcd-ladder.js builds the card when the drawer is first set up, so watch for it to appear.
  // setTimeout instead of requestAnimationFrame: rAF does not run while the tab is in the background.
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; scan(); }, 0);
  }).observe(document.documentElement, { childList: true, subtree: true });
  scan();
})();